import { useAccountStore } from "@/stores/account"
import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useNuxtApp,
  useRoute,
} from "#app"

export default defineNuxtRouteMiddleware((to) => {
  const isTokenExpired = useNuxtApp().nuxt2Context.$auth.isTokenExpired()
  const currentRoute = useRoute()
  if (
    useAccountStore().token !== null &&
    to.path.includes("/users/signin") >= 0 &&
    !isTokenExpired &&
    currentRoute.path !== "/"
  ) {
    return navigateTo("/")
  }
})
